import $ from 'jquery';

const SUMMARY_STATUS_SUCCESS = 'success';
const SUMMARY_STATUS_WARNING = 'warning';
const SUMMARY_STATUS_ERROR = 'error';

// TODO blockUi is limiting us from moving to jquery 4. It requires the isFunction function.
    // TODO first time block ui loads spinner is behind overlay and transparent, second time not. But with block ui?  
export function showLoadingSpinner(){
    
    var $blockUiSpinner = $( '#block-ui-spinner-icon-template' ).clone();
    $blockUiSpinner.removeAttr( 'id' );
    
    $.blockUI({
        message: '<div class="flex items-center justify-center">' + $blockUiSpinner.prop( 'outerHTML' ) + '</div>',
        css: {
            padding:        0,
            margin:         0,
            textAlign:      "center",
            color:          "#000",
            border:         "0",
            backgroundColor:"transparent",
            cursor:         "wait",
            width:          "auto",
            height:         "auto",
            transform:      "translateX(0%) translateY(0%)",
            top:            "50%",
            left:           "50%",
            zIndex:         "9999",
        },
        overlayCSS:  {
            backgroundColor: "#ffffff",
            opacity:         0.75,
            cursor:          "wait",
            zIndex:         "9999",
        }
    });
}

export function hideLoadingSpinner(){
    $.unblockUI();
}

var progressDialogInit = false;
var processedEventIds = [];

export function showProgressDialog(){
    
    processedEventIds = [];
    
    var $progressDialog = $( '#ajax-progress-dialog' );
    $progressDialog.find( '#ajax-progress-dialog-progress-container' ).removeClass( 'hidden' );
    $progressDialog.find( '#ajax-progress-dialog-current-task-icon' ).html('').addClass( 'hidden' );
    $progressDialog.find( '#ajax-progress-dialog-current-item' ).addClass( 'hidden' );
    
    $progressDialog.find( '#ajax-progress-dialog-footer' ).addClass( 'hidden' );
    
    var $currentMessageElement = $progressDialog.find( '#ajax-progress-dialog-current-task-message' );
    
    $currentMessageElement.html( $currentMessageElement.attr( 'data-init-message' ) );
    
    if ( !progressDialogInit ){
        $progressDialog.on( 'click', '#ajax-progress-dialog-finished-button', function(event){
            hideProgressDialog();
            hideLoadingSpinner();
        } );
        
        progressDialogInit = true;
    }
    
    hideProgressDialogSummary();
    
    $( '#ajax-progress-dialog' ).get(0).show();
}

export function hideProgressDialog(){
    $( '#ajax-progress-dialog' ).get( 0 ).close();
}

export function showProgressDialogSummary( finishCallback = null ){
    var $progressDialog = $( '#ajax-progress-dialog' );
    
    var $progressDialogSummaryContainer = $progressDialog.find( '#ajax-progress-dialog-summary-container' );
    
    $progressDialog.find( '#ajax-progress-dialog-finished-button' ).off( 'click.progress-dialog-summary' );
    if ( finishCallback ){
        $progressDialog.find( '#ajax-progress-dialog-finished-button' ).on( 'click.progress-dialog-summary', finishCallback );
    }
    
    $progressDialog.find( '#ajax-progress-dialog-progress-container' ).addClass( 'hidden' );
    $progressDialog.find( '#ajax-progress-dialog-footer' ).removeClass( 'hidden' );
    $progressDialogSummaryContainer.removeClass( 'hidden' );
}

export function hideProgressDialogSummary(){
    
    var $progressDialog = $( '#ajax-progress-dialog' );
    
    $progressDialog.find( '#ajax-progress-dialog-footer' ).addClass( 'hidden' );
    $progressDialog.find( '#ajax-progress-dialog-summary-container' ).addClass( 'hidden' );
    
    var $progressDialogSummaryContainer = $progressDialog.find( '#ajax-progress-dialog-summary-container' );
    $progressDialogSummaryContainer.find( '.ajax-progress-dialog-summary-icon' ).addClass( 'hidden' );
    $progressDialogSummaryContainer.find( '#ajax-progress-dialog-summary-title' ).html('');
    $progressDialogSummaryContainer.find( '#ajax-progress-dialog-summary-info-container' ).html('');
}

export function updateProgressDialogWithServerEvent( serverEvent ){
    
    var eventId = serverEvent.eventId ?? null;
    
    if ( eventId  &&  ( $.inArray( eventId, processedEventIds ) > -1 ) ){
        return;
    }
    
    processedEventIds.push( eventId );
    
    var $progressDialog = $( '#ajax-progress-dialog' );
    
    if ( typeof serverEvent[ 'eventType' ] !== "undefined" ){
        if ( serverEvent.eventType === 'progressUpdate' ){
            
            var $currentTaskIconElement = $progressDialog.find( '#ajax-progress-dialog-current-task-icon' );
            var $currentTaskMessageElement = $progressDialog.find( '#ajax-progress-dialog-current-task-message' );
            
            if ( serverEvent.icon ){
                $currentTaskIconElement.html( serverEvent.icon );
                $currentTaskIconElement.removeClass( 'hidden' );
            }
            
            $currentTaskMessageElement.html( serverEvent.message );
        }
        
        if ( serverEvent.eventType === 'itemUpdate' ){
            
            var $currentItem = $progressDialog.find( '#ajax-progress-dialog-current-item' );
            var $currentItemNameElement = $progressDialog.find( '#ajax-progress-dialog-current-item-name' );
            var $currentItemCountElement = $progressDialog.find( '#ajax-progress-dialog-current-item-count' );
            var $currentItemTotalElement = $progressDialog.find( '#ajax-progress-dialog-current-item-total' );
            
            $currentItemNameElement.html( serverEvent.item ?? '' );
            $currentItemCountElement.html( serverEvent.count ?? '' );
            
            if ( serverEvent.count && serverEvent.total ){
                $currentItemTotalElement.html( ' of ' + serverEvent.total );
            } else {
                $currentItemTotalElement.html( '' );
            }
            
            $currentItem.removeClass( 'hidden' );
            
        }
        
        if ( serverEvent.eventType === 'summaryItemUpdate' ){
            
            var $progressDialogSummaryContainer = $progressDialog.find( '#ajax-progress-dialog-summary-container' );
            var $progressDialogSummaryInfoContainer = $progressDialogSummaryContainer.find( '#ajax-progress-dialog-summary-info-container' );
            
            var $summaryItem = $( '<div class="flex gap-1"></div>' );
            
            if ( serverEvent.icon ){
                var iconSpan = $( "<span>" + serverEvent.icon + '</span>' );
                $summaryItem.append( iconSpan );
            }
            
            var $summaryInfoSpan = $( "<span></span>" );
            var $summaryInfoSpanHtml = '';
            var itemUsed = false;
            
            if ( serverEvent.item ){
                $summaryInfoSpanHtml += serverEvent.item + ' ';
                itemUsed = true;
            }
            
            if ( serverEvent.count ){
                $summaryInfoSpanHtml += serverEvent.count;
                
                if ( serverEvent.total ){
                    $summaryInfoSpanHtml += ' of ' + serverEvent.total;
                }
                itemUsed = true;
            }
            
            if ( itemUsed ){
                $summaryInfoSpanHtml += ": ";
            }
            
            $summaryInfoSpanHtml += serverEvent.message;
            
            $summaryInfoSpan.html( $summaryInfoSpanHtml );
            
            $summaryItem.append( $summaryInfoSpan );
            
            $progressDialogSummaryInfoContainer.append( $summaryItem );
    
        }
        
        if ( serverEvent.eventType === 'summaryResult' ){
            
            var $progressDialogSummaryContainer = $progressDialog.find( '#ajax-progress-dialog-summary-container' );
            
            $progressDialogSummaryContainer.find( '#ajax-progress-dialog-summary-title' ).html( serverEvent.message );
            $progressDialogSummaryContainer.find( '#ajax-progress-dialog-summary-icon-' + serverEvent.result ).removeClass( 'hidden' );
        }
    }
    
}
